import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/* Sans session valide, retour à la connexion en gardant la page demandée,
   pour y revenir une fois connecté. */
const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, sessionExpiree } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    return (
      <Navigate
        to="/connexion"
        replace
        state={{ retour: location.pathname + location.search, expiree: sessionExpiree }}
      />
    );
  }
  return <>{children}</>;
};

export default PrivateRoute;
